import { formatAddress } from '@/common/utils/address';
import type { IdentitySchema } from '$api-clients/generated';
import type { PartnerMailingAddress } from '../types';

type RestAddress = IdentitySchema.components['schemas']['Address'];

/**
 * Maps a REST address onto the feature's `PartnerMailingAddress`, attaching the
 * derived single-line `formattedAddress` (street, suite, then city/state/ZIP).
 */
export function toMailingAddress(
  address?: RestAddress | null,
): PartnerMailingAddress | null {
  if (!address) {
    return null;
  }

  return {
    ...address,
    formattedAddress: formatAddress(
      {
        street1: address.street1,
        street2: address.street2,
        city: address.city,
        state: address.state,
        zip: address.postalCode,
      },
      { includeStreet2: true, stripZip4: true },
    ),
  };
}
